module.exports = __webpack_public_path__ + "img/6.4385f612.jpg";